import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('portfolio');

const reducer = handleActions(
  {
    [actions.api.portfolio.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.portfolio.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.portfolio.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
  },
  { ...apiModuleDefaultState, data: {}, error: null }
);

export default reducer;
